import React, { FC } from 'react'
import { Box, Typography, makeStyles } from '@material-ui/core'

import T from 'components/FormattedMessage'

import whistleIconUrl from './assets/whistle.svg'

const useStyles = makeStyles(({ palette, spacing }) => {
  return {
    icon: {
      width: 102,
      height: 57,
      display: 'block',
      margin: `${spacing(3)}px auto`,
    },
    title: {
      color: palette.common.white,
      marginBottom: spacing(2),
    },
  }
})

const PlayerProfileEmpty: FC = () => {
  const classes = useStyles()

  return (
    <Box p={3}>
      <img
        src={whistleIconUrl}
        alt="whistle"
        className={classes.icon}
      />
      <Typography
        variant="h5"
        align="center"
        className={classes.title}
      >
        <T id="playerprofile_tab_empty_title" />
      </Typography>
      <Typography
        variant="subtitle1"
        align="center"
        color="inherit"
      >
        <T id="playerprofile_tab_empty_message" />
      </Typography>
    </Box>
  )
}

export default PlayerProfileEmpty
try {
    // @ts-ignore
    PlayerProfileEmpty.displayName = "PlayerProfileEmpty";
    // @ts-ignore
    PlayerProfileEmpty.__docgenInfo = { "description": "", "displayName": "PlayerProfileEmpty", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/PlayerLayer/components/PlayerProfile/components/PlayerProfileEmpty/PlayerProfileEmpty.tsx#PlayerProfileEmpty"] = { docgenInfo: PlayerProfileEmpty.__docgenInfo, name: "PlayerProfileEmpty", path: "src/components/PlayerLayer/components/PlayerProfile/components/PlayerProfileEmpty/PlayerProfileEmpty.tsx#PlayerProfileEmpty" };
}
catch (__react_docgen_typescript_loader_error) { }